import * as userService from '../services/users'
import * as transactionService from '../services/transactions'

import { LIST_TYPE, ROUTES } from '../constant'


export const getUsers = options => async (dispatch) => {
  dispatch({ type: 'GET_LIST' })

  try {
    const items = await userService.getUsers(options)

    return dispatch({
      items,
      type: 'GET_LIST_SUCCESS',
      listType: LIST_TYPE.USERS,
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'GET_LIST_ERROR',
    })
  }
}

export const getExpiredWallets = options => async (dispatch) => {
  dispatch({ type: 'GET_LIST' })

  try {
    const items = await userService.getExpiredWallets(options)

    return dispatch({
      items,
      type: 'GET_LIST_SUCCESS',
      listType: LIST_TYPE.USERS,
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'GET_LIST_ERROR',
    })
  }
}

export const getExpiredUsers = options => async (dispatch) => {
  dispatch({ type: 'GET_LIST' })

  try {
    const items = await userService.getExpiredUsers(options)

    return dispatch({
      items,
      type: 'GET_LIST_SUCCESS',
      listType: LIST_TYPE.USERS,
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'GET_LIST_ERROR',
    })
  }
}


export const addUser = data => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  try {
    const user = await userService.addUser(data)

    dispatch({ type: 'UNLOAD' })
    dispatch({
      type: 'SNACK_SUCCESS',
      snackUrl: `${ROUTES.USERS}/${user.id}`,
      message: 'L\'utilisateur a été créé avec succès. Cliquez ici pour accéder à sa fiche.',
    })

    return true
  } catch (err) {
    dispatch({ type: 'UNLOAD' })
    dispatch({
      type: 'SNACK_ERROR',
      message: err.message,
    })

    return false
  }
}

export const getUser = uid => async (dispatch) => {
  dispatch({ type: 'GET_ITEM' })

  try {
    const user = await userService.getUser(uid)

    return dispatch({
      item: user,
      type: 'GET_ITEM_SUCCESS',
      itemType: LIST_TYPE.USERS,
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'GET_ITEM_ERROR',
    })
  }
}

export const getUserTransactions = (userId, options = {}) => async (dispatch, getState) => {
  dispatch({ type: 'LOADING' })

  try {
    const transactions = await transactionService.getTransactionsByUser(userId, options)

    return dispatch({
      item: {
        ...getState().item,
        transactions,
      },
      type: 'GET_ITEM_SUCCESS',
      itemType: LIST_TYPE.USERS,
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'SET_SNACK_ERROR',
    })
  }
}


export const getUserWallets = (userId, options = {}) => async (dispatch, getState) => {
  dispatch({ type: 'LOADING' })

  try {
    const walletList = await userService.getUserWallets(userId, options)

    return dispatch({
      item: {
        ...getState().item,
        walletList,
      },
      type: 'GET_ITEM_SUCCESS',
      itemType: LIST_TYPE.USERS,
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'SET_SNACK_ERROR',
    })
  }
}


export const expireUserWallet = (userId, walletId) => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  try {
    await userService.expireUserWallet(userId, walletId)

    await dispatch(getUser(userId))
    return dispatch(getUserWallets(userId))
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'GET_ITEM_ERROR',
    })
  }
}


export const editUser = (userId, values) => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  try {
    const item = await userService.editUser(userId, values)

    dispatch({
      item,
      type: 'GET_ITEM_SUCCESS',
      itemType: LIST_TYPE.USERS,
    })

    dispatch({
      type: 'SNACK_SUCCESS',
      message: 'L\'utilisateur à bien été modifié',
    })

    return true
  } catch (err) {
    dispatch({
      type: 'SNACK_ERROR',
      message: err.message,
    })

    return false
  }
}
